import React, { useEffect, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useForm} from "react-hook-form";
import { getSim, addSim, editSim } from "../../services/sims/simsService";
import { OPERATORS } from "../utils/Constants";

const STATUS_OPTIONS = [
    { label: 'Activo', value: 'Activo', },
    { label: 'Pruebas locales', value: 'Pruebas locales', },
    { label: 'Testing', value: 'Testing', },
    { label: 'Inactivo', value: 'Inactivo' },
    { label: 'Dañado', value: 'Dañado' },    
];
const STATUS_DEACTIVATE = [
    'Inactivo','Dañado'   
];
const OPERATORS_OPTIONS = OPERATORS;

const SimcardView = () => {
    const navigate = useNavigate();
    const { simId } = useParams(); // Obtener el ID de la tarjeta SIM desde la URL
    
    const { register, handleSubmit, reset, watch, formState: {errors} } = useForm({});
    
    const status = watch("status");

    const handleCancel = useCallback(() => {
        navigate('/simcards');
    }, [navigate]);

    useEffect(() => {
        
        const fetchSim = async () => {
            if (simId !== 'add') {
                try {
                    const response = await getSim(simId);
                    // reset(response);
                    reset({...response, 
                            activationDate: response.activationDate.split('T')[0],
                            deactivationDate: response.deactivationDate ? response.deactivationDate.split('T')[0] : null
                        });
                } catch (error) {
                    console.error(error);
                }
            }
        };

        
        fetchSim();
    }, [simId,reset]);

    const onSubmit = handleSubmit ( async (data) => {
        
        const body = {...data,
            activationDate: data.activationDate.split('T')[0],
            deactivationDate: data.deactivationDate ? data.deactivationDate.split('T')[0] : null,
        };

        try {
            if (simId !== 'add') {
                const response =  await editSim(simId, body);
                alert(response.message ? response.message : "Sim actualizada exitosamente");
                
            } else {
                const response =  await addSim(body);
                alert(response.message ? response.message : "Sim creada exitosamente");
            }
            navigate('/simcards');
            
        } catch (error) {
            console.error('Error al enviar el formulario: ', error);
            alert("Error al enviar el formulario. Por favor, intenta de nuevo.");
        }
    });

    

    return (
        <div className='flex flex-col p-3'>
            <div className="flex max-sm:flex-col items-center justify-between mb-4">
                <h1 className="text-3xl font-semibold text-blue-600">Simcard</h1>
            </div>

            <div className="w-full max-w-5xl mx-auto ">
                <form onSubmit={onSubmit} className="flex flex-col items-center space-y-4 pb-2">
                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="iccid" className="block font-semibold text-black mb-1"> ICCID <span className="text-red-500">*</span></label>
                            <input id="iccid" type="number" autoComplete="name"
                                name="iccid"
                                placeholder="ICCID"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register('iccid',{
                                    required: {
                                        value: true,
                                        message: 'ICCD es requerida'
                                    },
                                    minLength: {
                                        value: 19,
                                        message: "La longitud mínima debe ser de 19 caracteres."
                                    },
                                    maxLength: {
                                        value: 19,
                                        message: "La longitud máxima debe ser de 19 caracteres."
                                    }
                                })}
                            />
                            {
                                errors.iccid && <span className="error">{errors.iccid.message}</span>
                            }
                        </div>

                        <div className='w-full'>
                            <label htmlFor="activationDate" className="block font-semibold text-black mb-1"> Fecha de activación <span className="text-red-500">*</span></label>
                            <input id="activationDate" type="date" 
                                name="activationDate"
                                placeholder="Fecha de activación"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register('activationDate',{
                                    required: {
                                        value: true,
                                        message: 'Fecha de activación es requerida'
                                    }
                                })}
                            />
                            {
                                errors.activationDate && <span className="error">{errors.activationDate.message}</span>
                            }
                        </div>
                    </div>
                    
                    <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="operator" className="block font-semibold text-black mb-1"> Operador <span className="text-red-500">*</span></label>
                            <select id="operator" 
                                name="operator" 
                                {...register("operator",{
                                    required: {
                                        value: true,
                                        message: 'Operador es requerido'
                                    }    
                                })}
                                className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                            >
                                <option value="" disabled> Operador </option>
                                {OPERATORS_OPTIONS.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            {
                                errors.operator && <span className="error">{errors.operator.message}</span>
                            }
                        </div>
                        <div className='w-full'>
                            <label htmlFor="status" className="block font-semibold text-black mb-1"> Estado <span className="text-red-500">*</span></label>
                            <select id="status" 
                                name="status" 
                                {...register("status",{
                                    required: {
                                        value: true,
                                        message: 'Estado es requerida'
                                    }    
                                })}
                                className="block w-full px-2 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                            >
                                <option value="" disabled> Estado </option>
                                {STATUS_OPTIONS.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            {
                                errors.status && <span className="error">{errors.status.message}</span>
                            }
                        </div>
                    </div>

                    {STATUS_DEACTIVATE.includes(status) && <div className="flex flex-col w-full md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                        <div className='w-full'>
                            <label htmlFor="deactivationDate" className="block font-semibold text-black mb-1"> Fecha de desactivación <span className="text-red-500">*</span></label>
                            <input id="deactivationDate" type="date" 
                                name="deactivationDate"
                                placeholder="Fecha de desactivación"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                {...register('deactivationDate',{
                                    required: {
                                        value: STATUS_DEACTIVATE.includes(status) ? true : false,
                                        message: 'Fecha de desactivación es requerida'
                                    }
                                })}
                            />
                            {
                                errors.deactivationDate && <span className="error">{errors.deactivationDate.message}</span>
                            }
                        </div>

                        <div className='w-full'>
                            <label htmlFor="deactivationReason" className="block font-semibold text-black mb-1"> Razón <span className="text-red-500">*</span></label>
                            <input id="deactivationReason" type="text" autoComplete="off"
                                name="deactivationReason"
                                placeholder="Razón"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md"
                                title="deactivationReason"
                                {...register("deactivationReason",{
                                    required: {
                                        value: STATUS_DEACTIVATE.includes(status) ? true : false,
                                        message: 'Razón es requerido'
                                    }  
                                })}
                            />
                            {
                                errors.deactivationReason && <span className="error">{errors.deactivationReason.message}</span>
                            }
                        </div>

                    </div>}


                    <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4">
                        <div className="w-full">
                            <button type="submit" className="flex flex-1 rounded w-full justify-center text-white bg-blue-600 hover:bg-blue-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                Guardar
                            </button>
                        </div>

                        <div className="w-full">
                            <button type="button" onClick={handleCancel} className="flex flex-1 rounded w-full justify-center text-white bg-red-600 hover:bg-red-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>             
    );
};

export default SimcardView;